export default __webpack_public_path__ + "asset/img/icon-video~c48965ed.png";